import React, {useEffect, useState} from 'react';
import {Translate} from "../../../../lang/lang";
import {useSelector} from "react-redux";
import {selectLang} from "../../../../store/reducers/main/main";
import {selectOrganizationTemplates} from "../../../../store/reducers/excel/excelReducer";
import {exportSalesAsync, selectSaleFilterOptions} from "../../../../store/reducers/warehouse/saleReducer";
import {TYPE_SALES_LIST_REPORT} from "../../../../enum/excel/ExcelTemplateTypes";
import {downloadFile} from "../../../../helpers/excel-uploader";
import toast from "react-hot-toast";
import {Dropdown} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSpinner} from "@fortawesome/free-solid-svg-icons";
import IconCloudUpload from "../../../../assets/icon/IconCloudUpload";

const UploadSalesToExcel = () => {

    const t = Translate;
    const lang = useSelector(selectLang);
    const organizationTemplates = useSelector(selectOrganizationTemplates);
    const filters = useSelector(selectSaleFilterOptions)
    const [itemTypeTemplates, setItemTypeTemplates] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const templates = organizationTemplates.filter(template => template.type === TYPE_SALES_LIST_REPORT) || [];
        setItemTypeTemplates(templates);
    }, [organizationTemplates])

    const exportSales = (uri) => {
        setLoading(true);
        exportSalesAsync(uri, {...filters})
            .then(({content, contentType}) => {
                downloadFile({
                    content: content,
                    contentType: contentType,
                    fileName: t(lang, 'warehouse.operation.item.common.list_sales'),
                });
            })
            .catch(() => {
                toast.error(t(lang, "warehouse.operation.item.common.toast.error"))
            })
            .finally(() => setLoading(false))
    }

    return (
        <Dropdown>
            <Dropdown.Toggle bsPrefix="toggle"
                             className={'btn-davr px-5 py-0 bg-white text-dark d-flex gap-2'}
                             variant="falcon-default"
                             size="sm"
                             disabled={loading}
            >
                {loading
                    ? <FontAwesomeIcon className="me-1" pulse={true} icon={faSpinner}/>
                    :  <IconCloudUpload />
                }
                {t(lang, 'items.common.download')}
            </Dropdown.Toggle>
            <Dropdown.Menu className='py-2'>
                {itemTypeTemplates.map((template, index) => {
                    return (
                        <Dropdown.Item as="button" key={index} onClick={() => exportSales(template.uri)}>
                            {t(lang, 'main.common.file.upload.template_name.prefix', {template_name: t(lang, `common.excel.template.name.${template.name}`)})}
                        </Dropdown.Item>
                    )
                })}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default UploadSalesToExcel;
